import { render, staticRenderFns } from "./ownerDetailHis.vue?vue&type=template&id=1d2f7a15&scoped=true"
import script from "./ownerDetailHis.vue?vue&type=script&lang=js"
export * from "./ownerDetailHis.vue?vue&type=script&lang=js"
import style0 from "./ownerDetailHis.vue?vue&type=style&index=0&id=1d2f7a15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2f7a15",
  null
  
)

export default component.exports